(() => {
  function fillByClass(className, value) {
    const wrapper = document.querySelector(`.${className}`);
    if (!wrapper) return;

    const el = wrapper.querySelector('input, textarea');
    if (!el) return;

    el.value = value;

    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function clean(text) {
    return text.replace(/\s+/g, ' ').trim();
  }

  async function getTotal() {
    const fallbackFromDom = () => {
      const el = document.querySelector('.cpb-product-price [data-testid="multycurrency-price"]');
      return el ? clean(el.innerText) : '';
    };

    try {
      const api = await window.CPB.createFrontApi('');
      const price = api?.State?.Product?.price;

      if (price == null) return fallbackFromDom();

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(price);
    } catch {
      return fallbackFromDom();
    }
  }

  function getConfigFromCartData(data) {
    const props = data?.items?.[0]?.properties;
    if (!props || typeof props !== 'object') return '';

    const excludedKeys = ['weight'];

    return Object.entries(props)
      .filter(([key]) => !key.startsWith('_') && !excludedKeys.includes(key))
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n');
  }

  async function buildUrl() {
    return new Promise(resolve => {
      _cpb.saveConfig(id => {
        resolve(location.origin + location.pathname + '?configid=' + id);
      });
    });
  }

  function openForm() {
    const btn = document.querySelector('.floating-button');
    if (btn) btn.click();
  }

  function updateButtonText() {
    const el = document.querySelector('.cpb-add-to-cart-button span');
    if (el) el.textContent = 'Get a quote!';
  }

  function installHook() {
    if (!window._cpb.settings) window._cpb.settings = {};

    window._cpb.settings.addToCartOverride = async (data) => {
      const url = await buildUrl();
      const config = getConfigFromCartData(data);
      const total = await getTotal();

      fillByClass('pf-design-url', url);
      fillByClass('pf-config', config);
      fillByClass('pf-cost', total);

      setTimeout(openForm, 150);

      return { success: true, redirect: false };
    };
  }

  function installLoaderTextObserver() {
    const observer = new MutationObserver(() => {
      const el = document.querySelector('.cpb-loader-text');
      if (!el) return;

      if (el.textContent.trim() === 'Adding to cart...') {
        el.textContent = 'Finalizing...';
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    updateButtonText();
    installHook();
    installLoaderTextObserver();
  });
})();
